export class PaymentServicesFailedError extends Error {
  constructor() {
    super('There are no payment methods available.');
    this.name = 'PaymentServicesFailedError';
  }
}
